import { range } from 'lodash';
import React from 'react';
import CSSModules from 'react-css-modules';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const Pager = ({ pagination = {}, onChangePage, size }) => {
  const { current, max_page, has_prev, has_next } = pagination;
  const DASH = -1;

  /*
     最初のページをS、最後のページをE、現在のページをCとする。
     Cから2個の範囲は確実に表示するようにする。(adjacent_count = 2)
     また、最小ページ数、最大ページ数も確実に表示されるようにする。
     すると、画面上の数が表示されるboxの数は9になる。
     （画面上のboxの数はfront,back含めて11）

     典型的には以下のような構造になる。 ()...リンクありbox []...リンクなしbox

     (<)(S)[-](C-2)(C-1)[C](C+1)(C+2)[-](E)(>)

     (<)(>) = 2
     (C-2)(C-1)(C+1)(C+2) = 4
     [-][-] = 2
     (S)(E) = 2
     (C) = 1

     計11

     S1,E15の場合,
     Cの移動により以下のようになる。

     C=1  [<][1](2)(3)(4)(5)(6)(7)[-](15)(>)
     C=2  (<)(1)[2](3)(4)(5)(6)(7)[-](15)(>)
     C=3  (<)(1)(2)[3](4)(5)(6)(7)[-](15)(>)
     C=4  (<)(1)(2)(3)[4](5)(6)(7)[-](15)(>)
     C=5  (<)(1)(2)(3)(4)[5](6)(7)[-](15)(>)
     C=6  (<)(1)[-](4)(5)[6](7)(8)[-](15)(>)
     C=7  (<)(1)[-](5)(6)[7](8)(9)[-](15)(>)
     C=8  (<)(1)[-](6)(7)[8](9)(10)[-](15)(>)
     C=9  (<)(1)[-](7)(8)[9](10)(11)[-](15)(>)
     C=10 (<)(1)[-](8)(9)[10](11)(12)[-](15)(>)
     C=11 (<)(1)[-](9)(10)[11](12)(13)(14)(15)(>)
     C=12 (<)(1)[-](9)(10)(11)[12](13)(14)(15)(>)
     C=13 (<)(1)[-](9)(10)(11)(12)[13](14)(15)(>)
     C=14 (<)(1)[-](9)(10)(11)(12)(13)[14](15)(>)
     C=15 (<)(1)[-](9)(10)(11)(12)(13)(14)[15][>]

     # アルゴリズム

     max<=9 なら全部出す

     cxを作る
     cx = max((S+2+2),min((E-2-2),C))

     first_half
     if cx-3 > S+1 => (S)[-](cx-2)(cx-1)
     else          => (S)(cx-3)(cx-2)(cx-1)

     second_half
     if c+3 < E-1 => (cx+1)(cx+2)[-](E)
     else         => (cx+1)(cx+2)(cx+3)(E)

     page_list = first_half + cx + second_half

     これらをレンダリングしながら、
     数がCと同じであればdisableそうでなければlinkにする。

   */

  const page_list = ((S, E, C) => {
    const adjacent_count = 2;
    if (E <= adjacent_count * 2 + 1 + 2 + 2) {
      return range(S, E + 1);
    }
    const cx = Math.max(Math.min(C, E - adjacent_count - 2), S + adjacent_count + 2);
    const first_half =
      cx - (1 + adjacent_count) > S + 1
        ? [S, DASH].concat(range(cx - adjacent_count, cx))
        : [S].concat(range(cx - adjacent_count - 1, cx));
    const second_half =
      cx + (1 + adjacent_count) < E - 1
        ? range(cx + 1, cx + adjacent_count + 1).concat([DASH, E])
        : range(cx + 1, cx + adjacent_count + 2).concat([E]);
    return first_half.concat([cx]).concat(second_half);
  })(1, max_page ?? 1, current ?? 1);

  const onClickLink = (pageTo) => (e) => {
    e.preventDefault();
    onChangePage(pageTo);
  };

  return (
    <Pagination className="d-flex justify-content-center" size={size}>
      <PaginationItem disabled={!has_prev}>
        <PaginationLink onClick={onClickLink(current - 1)} href="#">
          前のページ
        </PaginationLink>
      </PaginationItem>
      {page_list.map((page, i) =>
        page == DASH ? (
          <PaginationItem key={'pk_' + i} disabled>
            <PaginationLink>...</PaginationLink>
          </PaginationItem>
        ) : (
          <PaginationItem key={'pk_' + i} disabled={page == current}>
            <PaginationLink onClick={onClickLink(page)} href="#">
              {page}
            </PaginationLink>
          </PaginationItem>
        )
      )}
      <PaginationItem disabled={!has_next}>
        <PaginationLink onClick={onClickLink(current + 1)} href="#">
          次のページ
        </PaginationLink>
      </PaginationItem>
    </Pagination>
  );
};

export default CSSModules(Pager);
